import React, { PropsWithChildren } from 'react';

export const FormCard = ({ children }: PropsWithChildren<{}>) => (
  <>{children}</>
);
